import React, {useState, useEffect} from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import {useAuth} from "hooks/useAuth";
import PageTitle from "shared/ui/PageTitle";
import Loading from "shared/ui/Loading";
import CustomAccordion from "shared/ui/CustomAccordion";
import {getFaq} from "features/assistance/api/faq";

interface IFAQItem {
    title: string;
    content: string;
    id: string;
}

interface IFaq {
    category_id: number;
    items: IFAQItem[];
    [key: string]: any;
}

const Faq = () => {
    const {update, user} = useAuth();
    const [loading, setLoading] = useState<boolean>(true);
    const [faqs, setFaqs] = useState<IFaq[]>([]);

    useEffect(() => {
        getFaq()
            .then((response) => {
                if (response.data.success) {
                    setFaqs(response.data?.data?.values || []);
                } else {
                    update("error", {show: true, code: "A002"});
                }
            })
            .catch(() => {update("error", {show: true, code: "A001"})})
            .finally(() => setLoading(false));
    }, []);

    const filteredFaqs = faqs.filter(faq =>
        user.position === "student"
            ? faq.category_id === 4
            : faq.category_id !== 4
    );

    return (
        <Box component="main">
            <PageTitle>Întrebări frecvente</PageTitle>
            {loading ? (
                <Box mt={3} display="flex" alignItems="center" width="100%">
                    <Loading show={true}/>
                </Box>
            ) : (
                <Grid container spacing={3} direction="row" justifyContent="flex-start" alignItems="flex-start">
                    {filteredFaqs.map((faq, index) => (
                        <Grid item md={12} key={index}>
                            <CustomAccordion data={faq.items}/>
                        </Grid>
                    ))}
                </Grid>
            )}
        </Box>
    );
};

export default Faq;
